import { gql } from "@apollo/client";

export const CONTACT = gql`
  mutation CreateContact($input: InputCreateContact!) {
    CreateContact(input: $input) {
      message
    }
  }
`;
